<template>
    <v-container>
        <v-row align="center" justify="center">
            <v-col cols="8">
                <v-card outlined class="mx-auto" max-width="600">
                    <v-card-subtitle>
                        Cargar datos proyecto
                    </v-card-subtitle>
                    <v-card-text>
                        <v-row>
                            <v-col
                                cols="12"
                                class="py-2"
                            >
                                <v-btn-toggle
                                    v-model="selectMode"
                                    color="primary"
                                    mandatory
                                    group
                                >
                                    <v-btn value="add">
                                        Crear
                                    </v-btn>

                                    <v-btn value="update">
                                        Actualizar
                                    </v-btn>

                                </v-btn-toggle>
                            </v-col>
                        </v-row>
                        <v-row
                            lazy-validation
                        >
                            <v-col cols="12" style="margin-top: 0px" v-show="selectMode == 'update'">
                                <v-select v-model="selectDevice" :items="projectTest" item-value="_id" item-text="name" label="Projectos"
                                    outlined dense> </v-select>
                            </v-col>
                            <v-col cols="5" class="text-center" v-show="selectMode == 'add'">
                                <v-text-field
                                    v-model="projectName"
                                    :rules="nameRules"
                                    label="Nombre"
                                    outlined
                                    dense
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="7" class="text-center" v-show="selectMode == 'add'">
                                <v-text-field
                                    v-model="projectDescription"
                                    :rules="descriptionRules"
                                    label="Descripción"
                                    outlined
                                    dense
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" class="text-center">
                                <v-btn color="primary" @click="onPickFile">
                                    Cargar Archivo
                                </v-btn>
                            </v-col>
                            <!-- TODO: DISABLED!! -->
                            <v-col cols="6" class="text-center" :disabled="!hasProjectName">
                                <v-btn color="primary" :disabled="btnSaveValid" @click="sendData()">
                                    Guardar
                                </v-btn>
                            </v-col>
                            <v-col cols="12" class="text-center" v-if="!validData.valid && hasData">
                                <p> {{ validData.msg }}</p>
                            </v-col>
                        <!-- </v-form> -->
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12">
                <input type="file" style="display:none" ref="fileInput" @change="onFilePicked">
            </v-col>
        </v-row>
        
        <v-row align="center" justify="center" v-show="validData.valid && hasData">
            Ejemplo de datos cargados ({{ entries }} entradas)
            <v-col cols="12">
                <div style="margin-top: 10px">
                    <v-data-table
                        :headers="headersTable"
                        :items="dataTable"
                        :items-per-page="10"
                        class="elevation-1"
                        hide-default-footer
                    >
                    
                    </v-data-table>
                </div>
            </v-col>
        </v-row>

        <v-dialog v-model="dataLoading" hide-overlay persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Cargando datos
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dataLoadingReport" persistent width="300">
            <v-card color="primary text-center" dark>
                <v-card-text>
                    Subiendo reportes {{ textWaiting }}
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        outlined
                        text
                        @click="cancelUpload()"
                    >
                        Cancelar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import moment from 'moment'
import XLSX from 'xlsx'

export default {
    name: 'Import',
    data: () => ({
        selectMode: 'add',
        projectName: '',
        projectDescription:'',
        file: null,
        dataLoading: false,
        dataRaw: [],
        dataToImport: [],
        headers: [],
        headersTable: [],
        dataTable: [],
        selectDevice: null,
        sensor: [],
        btnControl: true,
        dataLoadingReport: false,
        textWaiting: '',
        cancel: false,
        entries: 0,
        // valid: false,
        // nameRules: [
        //     v => !!v || 'Nombre es requerido',
        // ],
    }),

    computed: {
        hasData() {
            return this.dataTable.length > 0
        },
        hasProjectName () {
            if ( this.selectMode === 'add' )
                return this.projectName.length > 0
            
            return false
        },
        validData() {
            if ( this.headers[0] !== 'ts' )
                return { valid: false, msg: 'Falta encabezado `ts`'}

            if ( this.headers.length < 2 )
                return { valid: false, msg: 'Faltan datos' }
            
            return { valid: true, msg: 'Ok' }
        },
        projectTest() {
            return this.$store.getters.projectTest
        },
        hasDevice() {
            return this.selectDevice != undefined
        },

        nameRules() {
            return [
                v => !!v || 'Nombre es requerido',
                v => !this.projectTest.some(e => e.name === v) || 'Proyecto ya existe'
            ]
        },

        descriptionRules() {
            return [
                v => !!v || 'Descripcion es requerida',
                v => !this.projectTest.some(e => e.name === v) || 'Proyecto ya existe'
            ]
        },

        isValid () {
            return !!this.projectName && !this.projectTest.some(e => e.name === this.projectName)
        },

        btnSaveValid () {
            if (this.selectMode === 'add') 
                return this.btnControl || !this.isValid
            else
                return this.btnControl
        }
        
    },

    methods: {
        onPickFile() {
            this.$refs.fileInput.click()
        },
        onFilePicked(event) {
            this.dataLoading = true
            this.file = event.target.files ? event.target.files[0] : null;
            if (this.file) {
                const reader = new FileReader();

                reader.onload = (e) => {
                    const bstr = e.target.result;
                    const wb = XLSX.read(bstr, {
                        type: 'binary', cellDates: true, cellNF: false, cellText: false });
                    
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    
                    const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
                    this.parseImportData(data)
                }

                reader.readAsBinaryString(this.file);
            }
        },
        
        parseImportData (data) {
            this.headersTable = []
            let headers = []
            let importObject = {}
            let dataRaw = []
            let startData = 0

            for (let i = 0; i < data.length; i++) {
                if (data[i].length == data[i + 1].length) {
                    headers = data[i]
                    dataRaw = data.slice(i + 1)
                    startData = i + 1
                    break
                }
            }

            this.headers = headers

            headers.forEach(header => {
                importObject[header] = null
                this.headersTable.push(
                    { text: header, value: header }
                )
            })
            
            this.dataRaw = dataRaw.filter (d => d.length > 0)
            let dataView = dataRaw.slice(0, 10)
            let dataViewTable = []
            
            dataView.forEach((arr) => {
                let newObject

                for (let i = 0; i < arr.length; i++) {
                    newObject = importObject
                    newObject[headers[i]] = arr[i]
                }

                dataViewTable.push({...newObject})
            })

            this.dataTable = dataViewTable

            this.parseDataToSend(this.dataRaw, this.headers)
            this.dataLoading = false
            this.btnControl = false
        },

        parseDataToSend  (dataView, headers) {
            let toSend = []

            for (let i = 0; i < dataView.length; i++) {
                const column = dataView[i]

                if (column.length == 0)
                    continue
                    
                let newObject = {}

                for (let j = 0; j < column.length; j++)
                    newObject[headers[j]] = column[j]

                toSend.push({...newObject })
            }

            this.entries = toSend.length * (Object.keys(toSend[0]).length - 1)
            this.dataToImport = toSend
        },

        prepareDataToImport (savedProject) {
            const { sensors, _id } = savedProject
            let prepareData = []

            this.dataToImport.forEach(data => {
                for (const key in data) {
                    if (data.hasOwnProperty(key) && key !== "ts") {
                        const sensor = sensors.find( e => e.name == key )
                        prepareData.push({
                            project: _id,
                            sensor: sensor._id,
                            ts: data.ts,
                            report: {
                                avg: data[key]
                            }
                        })
                    }
                }
            })

            return prepareData
        },  

        cancelUpload () {
            this.cancel = true
            this.textWaiting = `Cancelando proceso, espere`
        },

        async sendData () {
            let projectUploadReport

            if ( this.selectMode === 'add' ) {
                let newProject = {
                    name: this.projectName,
                    description: this.projectDescription,
                    sensors: this.headers.filter(item => item !== 'ts').map(nombre => ({ name: nombre }))
                }

                try {
                    projectUploadReport = await this.$store.dispatch('createProjectTest', newProject)
                } catch {
                    console.log("error no se puede guardar")                
                }

            } else {
                let addSensorProject = {
                    projectID: this.selectDevice,
                    sensors: this.headers.filter(item => item !== 'ts').map(nombre => ({ name: nombre }))
                }

                try {
                    projectUploadReport = await this.$store.dispatch('addSensorProjectTest', addSensorProject)
                } catch {
                    console.log("error no se puede guardar")
                }
            }

            try {
                let reports = this.prepareDataToImport(projectUploadReport)
                
                this.dataLoadingReport = true
                
                localStorage.setItem('continuum_tmp_upload', JSON.stringify(reports))
                
                this.textWaiting = `(0 de ${reports.length})`
                for (let i = 0; i < reports.length; i += 10) {
                    const segment = reports.slice(i, i + 10)
                    const response = await this.$store.dispatch('addReportsProjectTest', segment)

                    if (this.cancel)
                        break

                    this.textWaiting = `(${i+10} de ${reports.length})`
                }

                this.dataLoadingReport = false
                this.cancel = false
            } catch {
                console.log("TODO MALO!")
            }
        }
    },

    created() {
        this.$store.dispatch('pullProjectTest')
        moment.locale('es-us')
    }

}
</script>
